import { render, staticRenderFns } from "./messageviewattachments.vue?vue&type=template&id=2580b114&"
import script from "./messageviewattachments.vue?vue&type=script&lang=ts&"
export * from "./messageviewattachments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/Rnwood.Smtp4dev/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2580b114')) {
      api.createRecord('2580b114', component.options)
    } else {
      api.reload('2580b114', component.options)
    }
    module.hot.accept("./messageviewattachments.vue?vue&type=template&id=2580b114&", function () {
      api.rerender('2580b114', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messageviewattachments.vue"
export default component.exports